"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-hover-card";
//#region src/components/atoms/HoverCard/HoverCard.tsx
var r = (e) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "hover-card",
	...e
}), i = e((e, r) => /* @__PURE__ */ t(n.Trigger, {
	"data-slot": "hover-card-trigger",
	...e,
	ref: r
}));
i.displayName = "HoverCardTrigger";
var a = (e) => /* @__PURE__ */ t(n.Portal, {
	"data-slot": "hover-card-portal",
	...e
}), o = e((e, r) => /* @__PURE__ */ t(a, { children: /* @__PURE__ */ t(n.Content, {
	"data-slot": "hover-card-content",
	...e,
	ref: r
}) }));
o.displayName = "HoverCardContent";
var s = e((e, r) => /* @__PURE__ */ t(n.Arrow, {
	"data-slot": "hover-card-arrow",
	...e,
	ref: r
}));
s.displayName = "HoverCardArrow";
//#endregion
export { s as HoverCardArrow, o as HoverCardContent, a as HoverCardPortal, r as HoverCardRoot, i as HoverCardTrigger };
